module.exports = __webpack_public_path__ + "static/media/convective-icon-enhanced.e90c3063.svg";